import { Pipe, PipeTransform } from '@angular/core';
import {CreativeUnitUtils} from "../../../../../api/src/creative-unit-package/utils/creative-unit.utils";
import {
	CreativeUnitDimensionsDto,
	CreativeUnitDimensionsUnit,
} from "../../../../../api/src/creative-unit-package/models/creative-unit/creative-unit.dto";
import { CartItemType } from "../../_core/state/cart/cart.model";

@Pipe({
  name: 'dimension'
})
export class DimensionPipe implements PipeTransform {

  transform(item: any): CreativeUnitDimensionsDto {
	  if (!item || item.type !== CartItemType.AD_UNIT) {
		  return;
	  }

	  const itemDimensions = item?.dimensions || item?.itemData?.dimensions || item?.metadata?.dimensions;

	  const dimensions: CreativeUnitDimensionsDto = CreativeUnitUtils.convertToNewUnitSize(
		  {
			  ...itemDimensions,
			  defaultDisplayUnit: CreativeUnitDimensionsUnit.PIXELS
		  },
		  itemDimensions?.defaultDisplayUnit
	  );

	  if (!dimensions) {
		  return item;
	  }

	  return dimensions;
  }

}
